import {
    SAVE_STAMP,
} from '../Actions/stamps';

const INITIAL_STATE = {
    china: false,
    egypt: false,
    france: false,
    germany: false,
    italy: false,
    spain: false,
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case SAVE_STAMP:
            return {...state, [action.payload]: true};
        default:
            return state;
    }
}